<div class="zentra-admin-success-dialog">
  <h1 mat-dialog-title>Wholesaler Revenue Share</h1>

  <div mat-dialog-content class="message">
    <div
      class="warning-row"
      style="display: flex; gap: 12px; align-items: flex-start; margin: 12px 0"
    >
      <mat-icon color="warn">warning</mat-icon>
      <div>
        <strong>Important:</strong>
        <div>
          This change will not modify the existing wholesaler-partner agreement
          with the current wholesaler. The newly selected wholesaler will take
          effect at the subscription’s next renewal and will become the default
          for future renewals.
        </div>
      </div>
    </div>

    <br />

    <mat-form-field
      appearance="outline"
      floatLabel="always"
      style="width: 100%"
    >
      <mat-label>Select Wholesaler</mat-label>
      <mat-select
        [(value)]="selectedWholesalerEmail"
        panelClass="wholesaler-select-panel"
      >
        <mat-select-trigger>
          <ng-container *ngIf="selectedWholesaler">
            <span class="wholesaler-trigger-company">{{
              selectedWholesaler.userCompany
            }}</span>
            <span class="wholesaler-trigger-meta">
              &middot; Invited by {{ selectedWholesaler.userFirstName }}
              {{ selectedWholesaler.userLastName }}</span
            >
          </ng-container>
        </mat-select-trigger>
        <mat-option *ngFor="let w of data.wholesalers" [value]="w.userEmail">
          <div class="wholesaler-option-name">
            {{ w.userCompany }}
            <span *ngIf="w.userEmail === data.currentWholesalerEmail"
              >(Current)</span
            >
          </div>
          <div class="wholesaler-option-meta">
            Invited by {{ w.userFirstName }} {{ w.userLastName }} ({{
              w.userEmail
            }})
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div mat-dialog-actions class="actions">
    <button color="secondary" mat-flat-button (click)="onCancel()">
      Cancel
    </button>

    <button
      color="primary"
      mat-flat-button
      [disabled]="isUpdateDisabled()"
      (click)="onUpdate()"
    >
      Update
    </button>
  </div>
</div>
